import React, { useState } from "react";
import { Box, Grid2 as Grid, Tooltip, Typography } from "@mui/material";
import { NewOffsetInput as OffsetInput } from "./NewOffsetInput";
import { cssVar } from "../../theme/theme";
import Heading from "./Heading";
import Button from "./Button";
import { CommonFunctions } from "../utils/CommonFunctions";
import Input from "./Input";
import { HtmlHelpers } from "../constants/all-constant";

export interface INote {
  id: number;
  roleId?: number;
  notesText: string;
  createdOn: string;
  firstName: string;
  lastName: string;
  offset?: number;
  isInEditMode: boolean;
}

const NotesInputRow = ({
  isCurrentUserStudentOrTutor,
  note,
  onAdd,
  isCurrentSuperUser,
}: {
  isCurrentUserStudentOrTutor: boolean;
  note?: INote;
  onAdd(text: string, offsetInMinutes: number): void;
  isCurrentSuperUser?: any;
}) => {
  const [offsetInMinutes, setOffsetInMinutes] = useState<number | undefined>(
    undefined
  );
  const [text, setText] = useState<string>("");
  const [error, setError] = useState<string>("");
  const offsetErrorText = "Please enter valid input.";
  const validateAndCallback = () => {
    if (!text) return;
    if (!isCurrentUserStudentOrTutor) {
      if (offsetInMinutes === 0) {
        setError(offsetErrorText);
        return;
      }
    }
    const offsetMins = offsetInMinutes ?? 0;
    onAdd(text, offsetMins);
    setError("");
    setText("");
    setOffsetInMinutes(undefined);
  };

  return (
    <Grid container spacing={1} sx={{ padding: "10px 0px" }}>
      <Grid size={1.65}>
        {!isCurrentUserStudentOrTutor &&
          (text ? (
            <OffsetInput
              data-testid="offset-input"
              value={offsetInMinutes}
              onValueChanged={(e) => {
                setOffsetInMinutes(e);
                setError("");
              }}
              errorMessage={error}
            />
          ) : (
            <React.Fragment>
              {isCurrentSuperUser && (
                <React.Fragment>
                  <Typography
                    className="text-ellipsis"
                    style={{
                      marginLeft: "20px",
                      alignItems: "center",
                      fontSize: "1.25rem",
                    }}
                  >
                    Offset
                    {/* <Tooltip title="Use the format: 2D 5H, D= Days H= Hours">
                  <span
                    className="material-symbols-outlined"
                    style={{
                      fontSize: "1.2rem",
                      verticalAlign: "text-top",
                      color: cssVar("--color-info-main"),
                      marginLeft: "8px",
                    }}
                  >
                    info
                  </span>
                </Tooltip> */}
                  </Typography>
                  <Typography
                    className="text-ellipsis"
                    style={{
                      marginLeft: "20px",
                      fontSize: "0.87rem",
                      fontWeight: "bold",
                    }}
                  >
                    D {HtmlHelpers.FOUR_TIMES_SPACE}H
                  </Typography>
                </React.Fragment>
              )}
            </React.Fragment>
          ))}
      </Grid>
      <Grid size={10.35}>
        {(isCurrentSuperUser || isCurrentUserStudentOrTutor) && (
          <Input
            label=""
            name="noteText"
            minRows={3}
            maxRows={3}
            multiline={true}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Add Progress Notes"
          />
        )}
        {text && (
          <Box className="d-flex" style={{ marginTop: "5px" }}>
            <Button
              text="Cancel"
              type="button"
              variant="outlined"
              size="small"
              className="tinyBtn"
              fullWidth={false}
              isBold={true}
              onClick={() => {
                setText("");
                setOffsetInMinutes(undefined);
                setError("");
              }}
            />
            <Button
              text="Add"
              type="button"
              className="primary-bg-color ml-1 tinyBtn"
              size="small"
              fullWidth={false}
              isBold={true}
              onClick={validateAndCallback}
            />
          </Box>
        )}
      </Grid>
    </Grid>
  );
};

export default NotesInputRow;
